export const importantCampaignNames = {
  AfterLastVisit: 'After last visit',
  CheckedOutReview: 'Review',
  Lost6Months: 'Lost 80%',
  Lost9Months: 'Lost 60%',
  Lost12Months: 'Lost 40%',
  Lost15Months: 'Lost 20%'
}
